export enum StickyNoteTypeEnum {
    TaskComment = 1,
    EpisodeNote = 2,
    ReturnReason = 3,
    MissedVisit = 4
}
